import CustomerActionTypes from './actionTypes';

const CustomerActions = {
  getCustomers: (payload) => ({
    payload,
    type: CustomerActionTypes.GET_CUSTOMERS,
  }),
  getCustomersSuccess: (payload) => ({
    payload,
    type: CustomerActionTypes.GET_CUSTOMERS_SUCCESS,
  }),
  getCustomersFailed: () => ({
    type: CustomerActionTypes.GET_CUSTOMERS_FAILED,
  }),

  getCustomerDetails: (payload) => ({
    payload,
    type: CustomerActionTypes.GET_CUSTOMER_DETAILS,
  }),
  getCustomerDetailsSuccess: (payload) => ({
    payload,
    type: CustomerActionTypes.GET_CUSTOMER_DETAILS_SUCCESS,
  }),
  getCustomerDetailsFailed: () => ({
    type: CustomerActionTypes.GET_CUSTOMER_DETAILS_FAILED,
  }),

  getCustomerBookings: (payload) => ({
    payload,
    type: CustomerActionTypes.GET_CUSTOMER_BOOKINGS,
  }),
  getCustomerBookingsSuccess: (payload) => ({
    payload,
    type: CustomerActionTypes.GET_CUSTOMER_BOOKINGS_SUCCESS,
  }),
  getCustomerBookingsFailed: () => ({
    type: CustomerActionTypes.GET_CUSTOMER_BOOKINGS_FAILED,
  }),

  exportCustomerFile: (payload) => ({
    payload,
    type: CustomerActionTypes.EXPORT_CUSTOMER_FILE,
  }),
  exportCustomerFileSuccess: () => ({
    type: CustomerActionTypes.EXPORT_CUSTOMER_FILE_SUCCESS,
  }),
  exportCustomerFileFailed: () => ({
    type: CustomerActionTypes.EXPORT_CUSTOMER_FILE_FAILED,
  }),

  blockCustomer: (payload) => ({
    payload,
    type: CustomerActionTypes.BLOCK_CUSTOMER,
  }),
  blockCustomerSuccess: (payload) => ({
    payload,
    type: CustomerActionTypes.BLOCK_CUSTOMER_SUCCESS,
  }),
  blockCustomerFailed: () => ({
    type: CustomerActionTypes.BLOCK_CUSTOMER_FAILED,
  }),

  unblockCustomer: (payload) => ({
    payload,
    type: CustomerActionTypes.UNBLOCK_CUSTOMER,
  }),
  unblockCustomerSuccess: (payload) => ({
    payload,
    type: CustomerActionTypes.UNBLOCK_CUSTOMER_SUCCESS,
  }),
  unblockCustomerFailed: () => ({
    type: CustomerActionTypes.UNBLOCK_CUSTOMER_FAILED,
  }),

  updateCustomerLevel: (payload) => ({
    payload,
    type: CustomerActionTypes.UPDATE_CUSTOMER_LEVEL,
  }),
  updateCustomerLevelSuccess: (payload) => ({
    payload,
    type: CustomerActionTypes.UPDATE_CUSTOMER_LEVEL_SUCCESS,
  }),
  updateCustomerLevelFailed: () => ({
    type: CustomerActionTypes.UPDATE_CUSTOMER_LEVEL_FAILED,
  }),
};

export default CustomerActions;
